import React, { Component } from 'react';
import { Route, Switch, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Header } from 'components';
import { clearReduxStore } from 'containers/InitialStore';

import * as userActions from 'modules/user';
import * as loginActions from 'modules/login';

class CtHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModal: ''
    };
  }

  onLoginPage = () => {
    const { LoginActions } = this.props;

    LoginActions.setInitial();
  };

  // 제품 식별 정보
  onToggleModal = type => {
    this.setState({ isModal: type });
  };

  onLogout = () => {
    const { UserActions, LoginActions } = this.props;

    localStorage.removeItem('loginAdmin');
    localStorage.removeItem('loginUser');
    sessionStorage.removeItem('curUser');
    // 로그아웃 처리
    UserActions.logout();
    // 로그인 초기화
    LoginActions.setInitial();
  };

  render() {
    const { onLoginPage, onToggleModal, onLogout } = this;
    const { isAuth, user } = this.props;

    return (
      <Header
        isAuth={isAuth}
        isModal={this.state.isModal}
        user={user}
        onLoginPage={onLoginPage}
        onLogout={onLogout}
        onToggleModal={onToggleModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  isAuth: state.user.get('isAuth'),
  user: state.user.get('user')
});

const mapDispatchToProps = dispatch => ({
  UserActions: bindActionCreators(userActions, dispatch),
  LoginActions: bindActionCreators(loginActions, dispatch),
  Dispatch: dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(CtHeader);



// WEBPACK FOOTER //
// ./src/script/containers/header/CtHeader.js